import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Modal } from 'react-bootstrap'

import { formatMoney } from 'helpers/helpers'
import { httpOk, GET, POST, PUT, DELETE } from 'helpers/api'

// Цены на SMS: за СЕГМЕНТ и на страну (UZ и RU отличаются по себестоимости в разы).
// Резолв — от частного к общему: (login,pos,страна) → (login,страна) → (страна) → без страны.
// Старые списания не переоцениваются: в sms_messages цена лежит снимком.
const emptyItem = {
	login: '',
	pos_id: '',
	country_code: '',
	price: '',
	is_active: true,
}

function Index() {
	const { t } = useTranslation()
	const [data, setData] = useState([])
	const [modal, setModal] = useState(false)
	const [selectedItem, setSelectedItem] = useState(emptyItem)

	async function loadData() {
		const response = await GET('/admin/sms-prices', {}, { loader: true })
		if (httpOk(response)) setData(response.data?.data || [])
	}

	function toggleModal(bool = false, item = emptyItem) {
		setSelectedItem({
			...emptyItem,
			...item,
			login: item.login || '',
			pos_id: item.pos_id || '',
			country_code: item.country_code || '',
			price: item.price ?? '',
			is_active: item.is_active === undefined ? true : !!item.is_active,
		})
		setModal(bool)
	}

	async function save(e) {
		e.preventDefault()

		const payload = {
			...selectedItem,
			price: String(selectedItem.price).replace(/\s/g, ''),
			login: selectedItem.login || null,
			pos_id: selectedItem.pos_id || null,
			country_code: selectedItem.country_code || null,
		}

		const response = selectedItem.id
			? await PUT('/admin/sms-prices', payload, { loader: true })
			: await POST('/admin/sms-prices', payload, { loader: true })

		if (httpOk(response)) {
			setModal(false)
			loadData()
		}
	}

	async function remove(item) {
		const response = await DELETE(`/admin/sms-prices/${item.id}`, {}, { loader: true })
		if (httpOk(response)) loadData()
	}

	useEffect(() => {
		loadData()
	}, [])

	return (
		<>
			<div className="page-header d-flex justify-content-between">
				<h4 className="vertical-center">{t('sms_prices')} [{data.length}]</h4>
				<button className="btn-rounded btn btn-primary" onClick={() => toggleModal(true)}>
					{t('create')}
				</button>
			</div>

			<div className="card">
				<div className="card-body">
					<div className="table-responsive">
						<table className="table table-bordered">
							<thead>
								<tr>
									<th style={{ 'width': '25%' }}>{t('login')}</th>
									<th style={{ 'width': '20%' }}>{t('pos')}</th>
									<th style={{ 'width': '15%' }}>{t('sms_countries')}</th>
									<th style={{ 'width': '15%' }} className="text-end">{t('price')}</th>
									<th style={{ 'width': '10%' }} className="text-center">{t('status')}</th>
									<th style={{ 'width': '15%' }} className="text-center"></th>
								</tr>
							</thead>
							<tbody>
								{data.map((item, index) => (
									<tr key={index}>
										<td>{item.login || <span className="text-muted">{t('sms_base_price')}</span>}</td>
										<td>{item.pos_name || '—'}</td>
										<td>{item.country_code || '—'}</td>
										<td className="text-end">{formatMoney(item.price)}</td>
										<td className="text-center">
											<span className={'badge ' + (item.is_active ? 'bg-success' : 'bg-secondary')}>
												{item.is_active ? t('active') : t('inactive')}
											</span>
										</td>
										<td className="text-center">
											<div className="d-flex justify-content-center gap-2">
												<button className="btn btn-sm btn-outline-dark" onClick={() => toggleModal(true, item)}>
													<i className="uil-edit-alt" />
												</button>
												{(item.login || item.pos_id) &&
													<button className="btn btn-sm btn-outline-danger" onClick={() => remove(item)}>
														<i className="uil-trash-alt" />
													</button>
												}
											</div>
										</td>
									</tr>
								))}
								{data.length === 0 &&
									<tr><td colSpan="6" className="text-center text-muted">{t('list_empty')}</td></tr>
								}
							</tbody>
						</table>
					</div>
				</div>
			</div>

			<Modal show={modal} animation={false} centered onHide={() => setModal(false)}>
				<Modal.Header closeButton>
					<Modal.Title>{selectedItem.id ? t('edit') : t('create')}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<form onSubmit={save} autoComplete="off">
						{!selectedItem.id &&
							<>
								<div className="form-group">
									<label>{t('login')}</label>
									<input type="text" className="form-control" value={selectedItem.login}
										placeholder={t('sms_base_price')}
										onChange={(e) => setSelectedItem({ ...selectedItem, 'login': e.target.value })} />
								</div>
								<div className="form-group">
									<label>{t('pos')} ID</label>
									<input type="number" className="form-control" value={selectedItem.pos_id}
										onChange={(e) => setSelectedItem({ ...selectedItem, 'pos_id': e.target.value })} />
								</div>
								<div className="form-group">
									<label>{t('sms_countries')}</label>
									<input type="text" className="form-control" value={selectedItem.country_code}
										placeholder="UZ" maxLength="2"
										onChange={(e) => setSelectedItem({ ...selectedItem, 'country_code': e.target.value.toUpperCase() })} />
								</div>
							</>
						}

						<div className="form-group">
							<label>{t('price')}<span className="required-mark">*</span></label>
							<input type="number" className="form-control" value={selectedItem.price}
								onChange={(e) => setSelectedItem({ ...selectedItem, 'price': e.target.value })} />
						</div>

						<div className="form-check form-switch form-switch-lg">
							<input type="checkbox" className="form-check-input" id="priceActive"
								checked={!!selectedItem.is_active}
								onChange={(e) => setSelectedItem({ ...selectedItem, 'is_active': e.target.checked })} />
							<label className="form-check-label" htmlFor="priceActive">{t('active')}</label>
						</div>

						<div className="d-flex gap-2 w-100 mt-3">
							<button type="button" className="btn btn-outline-warning w-100" onClick={() => setModal(false)}>
								{t('cancel')}
							</button>
							<button type="submit" className="btn btn-primary w-100">{t('save')}</button>
						</div>
					</form>
				</Modal.Body>
			</Modal>
		</>
	)
}

export default Index
